import React, { Component } from 'react';
import store from 'store';
import { STATE } from 'services/3dviewer/moving-controls/synchronizeController';

import StyleSelectionMobile from '../styleSelectionMobile';
import ViewChangeMenu from '../viewChangeMenu';

import back from 'asset/image/back.svg';
import ToolBarMobile from '../toolbarMobile';

export default class FunctionBarMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFPview: false,
            isTOPview: false,
        };
    }

    componentDidMount() {
        store.subscribe(this.setStyleList);
    }

    setStyleList = () => {
        const { viewButton } = store.getState();
        if (viewButton) {
            const { viewState } = viewButton;
            this.setState({
                isFPview: viewState == STATE.FPVIEW,
                isTOPview: viewState == STATE.FLOORPLAN,
            });
        }
    };

    render() {

        const containerDisplay = (this.state.isFPview) ?
        {
          background: 'black'
        } :
        {
          background: 'transparent'
        }

        return (
            <>
                {<div className='functionBar' style={containerDisplay}>
                    {
                        this.props.isMultiStyle && this.state.isFPview && <StyleSelectionMobile parent={this.props.parent} mode={this.props.mode} RWD={this.props.RWD} />
                    }
                    {(this.props.viewLoadCompleted || this.props.isNotFirst) && (
                        <ViewChangeMenu
                            viewerCameraController={
                                this.props.leftScene.threeScene.viewerCameraController
                            }
                            objectManager={this.props.ObjectManagers}
                            parent={this.props.parent}
                            type={this.props.RWD}
                            display={this.props.viewLoadCompleted}
                            isFPview={this.state.isFPview}
                        />
                    )}
                    {this.state.isFPview && <ToolBarMobile
                        mode={this.props.mode}
                        parent={this.props.parent}
                        RWD={this.props.RWD}
                        viewerCameraController={
                            this.props.leftScene != null
                                ? this.props.leftScene.threeScene.viewerCameraController
                                : null
                        }
                    />}
                </div>
                }
            </>
        )
    }
}
